export interface Credentials {
  durchwahl: string;
  password: string;
}

export interface CredentialStore {
  load(): Credentials | null;
  save(c: Credentials, remember: boolean): void;
  clear(): void;
}

export const CREDENTIALS_KEY = 'webtelefon.credentials.v1';

function parse(raw: string | null): Credentials | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw) as Partial<Credentials> | null;
    if (v && typeof v.durchwahl === 'string' && typeof v.password === 'string') {
      return { durchwahl: v.durchwahl, password: v.password };
    }
  } catch {
    // ungültiges JSON
  }
  return null;
}

function safe<T>(fn: () => T, fallback: T): T {
  try {
    return fn();
  } catch {
    return fallback;
  }
}

export function createCredentialStore(local: Storage | null, session: Storage | null): CredentialStore {
  const remove = (s: Storage | null) => safe(() => s?.removeItem(CREDENTIALS_KEY), undefined);
  return {
    load() {
      return (
        parse(safe(() => session?.getItem(CREDENTIALS_KEY) ?? null, null)) ??
        parse(safe(() => local?.getItem(CREDENTIALS_KEY) ?? null, null))
      );
    },
    save(c, remember) {
      const target = remember ? local : session;
      remove(remember ? session : local);
      safe(() => target?.setItem(CREDENTIALS_KEY, JSON.stringify(c)), undefined);
    },
    clear() {
      remove(local);
      remove(session);
    },
  };
}
